module.exports = __webpack_public_path__ + "img/pn.4d842b78.svg";